export const actionTypes = {
  GET_LANGUAGES: 'GET_LANGUAGES',
  GET_LANGUAGES_SUCCESS: 'GET_LANGUAGES_SUCCESS',
  GET_LANGUAGES_V3: 'GET_LANGUAGES_V3',
  GET_LANGUAGES_V3_SUCCESS: 'GET_LANGUAGES_V3_SUCCESS',
};

const getLanguages = () => ({
  type: actionTypes.GET_LANGUAGES,
});

const getLanguagesSuccess = (languages) => ({
  type: actionTypes.GET_LANGUAGES_SUCCESS,
  languages,
});

const getLanguagesV3 = () => ({
  type: actionTypes.GET_LANGUAGES_V3,
});

const getLanguagesV3Success = (languagesV3) => ({
  type: actionTypes.GET_LANGUAGES_V3_SUCCESS,
  languagesV3,
});

export {
  getLanguages,
  getLanguagesSuccess,
  getLanguagesV3,
  getLanguagesV3Success,
};
